
import DrawBase from "../DrawBase"
import EditCircle from "./EditCircle"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawCircle extends DrawBase {

    constructor(options) {
        super(options);
    }


    getEditInterface(){
        return EditCircle;
    }

    getTypeName() {
        return "圆";
    }

    getType() {
        return "circle_Nor";
    }

    checkLeftClick() {
        if (this.positionsTemp.length <= 1) {
            return true;
        }
        return false;
    }

    checkMouseMove() {
        if (this.positionsTemp.length <= 1) {
            return false;
        }
        return true;
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var minR = 1;
        var positions = [];
        var semiAxisProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
            }
            positions = positionsArr ? positionsArr : $this.positions;
            var center = positions[0];
            var outline = positions[1];

            var r= Cesium.Cartesian3.distance(center, outline);
            return r ? r : r + minR;
        }, false);

        var ellipse = this.createEllipse(semiAxisProperty);
        entity.position = this.positionsTemp[0].clone();
        entity.ellipse = ellipse;

    }

    loadDynamicGraph(entity, data) {
        var $this = this;
        var minR = 1;
        var positions = JSON.parse(data.editPositions);
        var semiAxisProperty = new $this.Cesium.CallbackProperty(function () {
            var center = positions[0];
            var outline = positions[1];

            var r= Cesium.Cartesian3.distance(center, outline);
            return r ? r : r + minR;
        }, true);

        var ellipse = this.createEllipse(semiAxisProperty);
        entity.position = positions[0];
        entity.ellipse = ellipse;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "ellipse")
    }
}



export default DrawCircle;